import {useState} from "react";
import {useTranslation} from "react-i18next";

import {ComboboxGeneric} from "@/components/ui/combobox-generic";
import {getStorageItem} from "@/src/modules/core/lib";

import {tDarTypeName} from "../lib/dar-code-i18n";
import {DailyActivityReportType} from "../types";

type DarTypeComboboxProps = {
  value: DailyActivityReportType | null;
  onChange: (value: DailyActivityReportType | null) => void;
};

export function DarTypeCombobox({value, onChange}: DarTypeComboboxProps) {
  const {t} = useTranslation("dar");
  const [dailyActivityReportTypes] = useState<DailyActivityReportType[]>(
    getStorageItem("dailyActivityReportTypes"),
  );

  const visibleTypes = (dailyActivityReportTypes ?? []).filter(
    (darType) => (darType.visible ?? 1) === 1,
  );

  return (
    <ComboboxGeneric<DailyActivityReportType>
      items={visibleTypes}
      value={value}
      onChange={onChange}
      getItemKey={(item) => `dar-type-${item.daily_activity_report_type_id}`}
      getItemLabel={(item) => tDarTypeName(item.type, t)}
      isItemEqual={(item, selected) =>
        item.daily_activity_report_type_id === selected?.daily_activity_report_type_id
      }
      placeholder={t("select_type")}
      emptyMessage="No items found."
    />
  );
}
